import { Link } from "react-router-dom";
import { useSiteSettings } from "@/services/siteSettings";

export default function Hero() {
  const { get } = useSiteSettings();
  const brochureUrl = get("brochure_url", "/downloads/nomadlivings-brochure.pdf");
  return (
    <section id="top" className="relative w-full min-h-[100svh] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20luxury%20A-frame%20villas%20nestled%20in%20a%20lush%20green%20mountain%20valley%20at%20golden%20sunrise%2C%20modular%20wooden%20cabins%20with%20large%20triangular%20glass%20windows%2C%20surrounded%20by%20pine%20forest%20and%20mist%2C%20warm%20golden%20and%20green%20tones%2C%20premium%20hospitality%20real%20estate%20photography%2C%20high%20detail&width=1800&height=1200&seq=hero-villa-x1&orientation=landscape&nocache=true"
        alt="Luxury A-frame villas nestled in a green mountain valley at sunrise"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent"></div>

      <div className="relative z-10 w-full px-4 md:px-8 max-w-6xl mx-auto text-center pt-28 pb-20">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-xs md:text-sm font-medium tracking-wide px-4 py-1.5">
            <i className="ri-home-4-line text-accent-400"></i>
            Modular A-Frame Villas · Govianu Group
          </span>
        </div>

        <h1 className="font-heading text-3xl sm:text-4xl md:text-6xl leading-tight md:leading-[1.1] text-background-50 mt-6 md:mt-8 animate-fade-up delay-100">
          Own a Premium A-Frame Villa.
          <span className="block text-accent-300 italic">Earn. Stay. Build Wealth.</span>
        </h1>

        <p className="max-w-2xl mx-auto text-background-100/95 text-sm md:text-lg mt-6 md:mt-7 leading-relaxed animate-fade-up delay-200">
          Invest in modular A-frame villas designed for staycations, Airbnb rentals, boutique
          resorts and holiday homes — professionally managed, fully furnished, and built for
          28-40% annual returns.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mt-8 md:mt-10 animate-fade-up delay-300">
          <Link
            to="/investments"
            className="inline-flex items-center justify-center gap-2 w-full sm:w-auto text-sm md:text-base font-semibold whitespace-nowrap rounded-full bg-accent-500 text-background-50 px-7 md:px-9 py-3.5 hover:bg-accent-600 transition-colors"
          >
            Explore Villa Options
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 w-full sm:w-auto text-sm md:text-base font-semibold whitespace-nowrap rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/40 text-background-50 px-7 md:px-9 py-3.5 hover:bg-background-50 hover:text-primary-800 transition-colors"
          >
            Schedule a Site Visit
          </Link>
          <a
            href={brochureUrl}
            download
            className="inline-flex items-center justify-center gap-2 w-full sm:w-auto text-sm md:text-base font-semibold whitespace-nowrap rounded-full bg-background-50/15 backdrop-blur-sm border border-accent-400/60 text-background-50 px-7 md:px-9 py-3.5 hover:bg-accent-500 hover:border-accent-500 transition-colors"
          >
            <i className="ri-download-2-line text-accent-300"></i>
            Download Brochure
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mt-10 md:mt-12 text-background-100 text-xs md:text-sm animate-fade-up delay-400">
          <span className="inline-flex items-center gap-2"><i className="ri-home-4-line text-accent-400"></i> Modular A-Frame Design</span>
          <span className="inline-flex items-center gap-2"><i className="ri-stack-line text-accent-400"></i> Multiple Revenue Models</span>
          <span className="inline-flex items-center gap-2"><i className="ri-line-chart-line text-accent-400"></i> 28-40% Annual ROI</span>
        </div>
      </div>

      <a
        href="#investments"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 text-background-50/80 text-xs animate-float"
        aria-label="Scroll down"
      >
        <span className="tracking-widest uppercase text-[10px]">Scroll</span>
        <i className="ri-arrow-down-line text-lg"></i>
      </a>
    </section>
  );
}